// Miscellaneous components
import Layout from './views/Layout.vue';
import Window from './views/Window.vue';
import Home from './views/Home.vue';
import Login from './views/auth/Login.vue';
import Register from './views/auth/Register.vue';

// Admin components
import AdminLayout from './views/admin/Layout.vue';
import Main from './views/admin/Main.vue';

import AllUsers from './views/admin/users/AllUsers';
import CreateUser from './views/admin/users/CreateUser.vue';
import EditUser from './views/admin/users/EditUser.vue';

import AllClients from './views/admin/clients/AllClients.vue';
import CreateClient from './views/admin/clients/CreateClient.vue';
import EditClient from './views/admin/clients/EditClient.vue';

import AllEvents from './views/admin/events/AllEvents.vue';
import CreateEvent from './views/admin/events/CreateEvent.vue';
import EditEvent from './views/admin/events/EditEvent.vue';

// Client components
import ClientLayout from './views/client/Layout.vue';
import ClientProfile from './views/client/Profile.vue';
import ClientEvents from './views/client/Events.vue';
import ClientEvent from './views/client/Event.vue';
import ClientCreateInvite from './views/client/CreateInvite.vue';
import ClientEditInvite from './views/client/EditInvite.vue';
import ClientViewInvite from './views/client/Invite.vue';

// Invitee components
import InviteeLayout from './views/invitee/Layout.vue';
import InviteeInvites from './views/invitee/Invites.vue';
import InviteeInvite from './views/invitee/Invite.vue';
import InviteeInvalid from './views/invitee/Invalid.vue';

export default [
    {
        path: '/',
        component: Layout,
        children: [
            {
                path: "",
                component: Home
            },

            {
                path: 'login',
                component: Login
            },

            {
                path: 'register',
                component: Register
            },
        ]
    },
    
    {
        path: '/admin',
        component: AdminLayout,
        redirect: "/",
        meta: {
            breadcrumb: "Admin",
            requires_auth: true,
            roles_required: ["admin"]
        },
        children: [

            {
              path: '',
              component: Main,
              meta: {
                  breadcrumb: 'Main'
              }
            },

            {
                path: 'users',
                component: Window,
                meta: {
                    breadcrumb: "Users"
                },
                children: [
                    {
                        path: '',
                        component: AllUsers,
                        meta: {
                            breadcrumb: "All Users"
                        }
                    },

                    {
                        path: 'create',
                        component: CreateUser,
                        meta: {
                            breadcrumb: "Create"
                        }
                    },

                    {
                        path: 'edit/:id',
                        name: 'edit-user',
                        component: EditUser,
                        props: true,
                        meta: {
                            breadcrumb: "Edit"
                        }
                    }
                ]
            },
            {
                path: 'clients',
                component: Window,
                meta: {
                    breadcrumb: "Clients"
                },
                children: [
                    {
                        path: '',
                        component: AllClients,
                        meta: {
                            breadcrumb: "All Clients"
                        }
                    },

                    {
                        path: 'create',
                        component: CreateClient,
                        meta: {
                            breadcrumb: "Create"
                        }
                    },

                    {
                        path: 'edit/:id',
                        name: 'edit-client',
                        component: EditClient,
                        props: true,
                        meta: {
                            breadcrumb: "Edit"
                        }
                    }
                ]
            },

            {
                path: 'events',
                component: Window,
                meta: {
                    breadcrumb: "Events"
                },
                children: [
                    {
                        path: '',
                        component: AllEvents,
                        meta: {
                            breadcrumb: "All Events"
                        }
                    },

                    {
                        path: 'create',
                        component: CreateEvent,
                        meta: {
                            breadcrumb: "Create"
                        }
                    },

                    {
                        path: 'edit/:id',
                        name: 'edit-event',
                        component: EditEvent,
                        props: true,
                        meta: {
                            breadcrumb: "Edit"
                        }
                    }
                ]
            },
        ]
    },
    
    {
        path: '/client',
        component: ClientLayout,
        redirect: '/client/events',
        meta: {
            breadcrumb: "Client",
            requires_auth: true,
            roles_required: ["admin", "client"]
        },
        children: [
            {
                path: "profile",
                component: ClientProfile
            },

            {
                path: "events",
                component: ClientEvents,
                meta: {
                    breadcrumb: "Events"
                }
            },

            {
                path: "event/:id",
                component: Window,
                props: true,
                meta: {
                    breadcrumb: "Event"
                },
                children: [
                    {
                        path: "",
                        name: 'event',
                        component: ClientEvent,
                        props: true,
                        meta: {
                            breadcrumb: "Manage"
                        }
                    },

                    {
                        path: "send-invite",
                        name: 'send-invite',
                        component: ClientCreateInvite,
                        props: true,
                        meta: {
                            breadcrumb: "Send Invite"
                        }
                    },

                    {
                        path: "edit-invite/:invite_id",
                        name: "edit-invite",
                        component: ClientEditInvite,
                        props: true,
                        meta: {
                            breadcrumb: "Invite"
                        }
                    },

                    {
                        path: "invite/:invite_id",
                        name: "invite",
                        component: ClientViewInvite,
                        props: true,
                        meta: {
                            breadcrumb: "Invite"
                        }
                    },
                ]
            },

                
        ]
    },
    {
        path: '/invitee',
        component: InviteeLayout,
        redirect: '/',
        // redirect: "/invitee/invite/6f9d30c8-990c-4dbe-a8da-599f0a9ac4e2", //TODO hack for demo
        meta: {
            breadcrumb: "Invitee",
            requires_auth: true,
            roles_required: ["admin", "invitee"]
        },
        children: [
            {
                path: "invalid",
                component: InviteeInvalid,
                meta: {
                    breadcrumb: "Invalid"
                }
            },
            {
                path: "invites",
                component: InviteeInvites,
                meta: {
                    breadcrumb: "Invites"
                }
            },

            {
                path: "invite/:id",
                name: "view-invite",
                props: true,
                component: InviteeInvite,
                meta: {
                    breadcrumb: "Invite"
                }
            }
        ]
    },

    {
        path: "*",
        redirect: "/"
    }
];